export default __webpack_public_path__ + "static/media/new-hero-4.a8edc786.svg";